export const ADD_MOVIE = 'ADD_MOVIE'
export const TOGGLE_MOVIE = 'TOGGLE_MOVIE'
export const REMOVE_MOVIE = 'REMOVE_MOVIE'

export const SEARCH_ASYNC_START = 'SEARCH_ASYNC_START'
export const SEARCH_ASYNC_SUCCESS = 'SEARCH_ASYNC_SUCCESS'
export const SEARCH_ASYNC_ERROR = 'SEARCH_ASYNC_ERROR'
export const SEARCH_CLEAR = 'SEARCH_CLEAR'

export const MOVIE_ASYNC_START = 'MOVIE_ASYNC_START'
export const MOVIE_ASYNC_SUCCESS = 'MOVIE_ASYNC_SUCCESS'
export const MOVIE_ASYNC_ERROR = 'MOVIE_ASYNC_ERROR'
export const MOVIE_CLEAR = 'MOVIE_CLEAR'

export const CHANGE_FILTER = 'CHANGE_FILTER'


